module.exports = __webpack_public_path__ + "editor/icon-whatsapp-default-760c3d436d7a0f04cfdc44c79de356ff.svg";